import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ShippingInfoModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit?: (data: ShippingData) => void; // Tornado opcional para modo visualização
  initialData?: ShippingData;
  isViewMode?: boolean; // Novo prop para modo visualização
}

export interface ShippingData {
  mawb: string;
  hawb: string;
  shipDate: string;
  arrivalDate: string;
}

const ShippingInfoModal: React.FC<ShippingInfoModalProps> = ({ 
  show, 
  onClose, 
  onSubmit, 
  initialData, 
  isViewMode = false 
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<ShippingData>({
    mawb: '',
    hawb: '',
    shipDate: '',
    arrivalDate: '',
  });

  // Preenche os dados quando initialData muda ou quando o modal é aberto
  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData, show]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setFormData({
      mawb: '',
      hawb: '',
      shipDate: '',
      arrivalDate: '',
    });
    onClose();
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(formData);
    }
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isViewMode ? t('shipInfo.labels.shippingDetails') : t('shipInfo.labels.shippingInformation')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={handleSubmit}>
          <Form.Group controlId="formMawb" className="mb-3">
            <Form.Label>{t('shipInfo.fields.mawb')}</Form.Label>
            <Form.Control
              type="text"
              name="mawb"
              value={formData.mawb}
              onChange={handleChange}
              readOnly={isViewMode}
              plaintext={isViewMode}
            />
          </Form.Group>

          <Form.Group controlId="formHawb" className="mb-3">
            <Form.Label>{t('shipInfo.fields.hawb')}</Form.Label>
            <Form.Control
              type="text"
              name="hawb"
              value={formData.hawb}
              onChange={handleChange}
              readOnly={isViewMode}
              plaintext={isViewMode}
            />
          </Form.Group>

          <Form.Group controlId="formShipDate" className="mb-3">
            <Form.Label>{t('shipInfo.fields.shipDate')}</Form.Label>
            <Form.Control
              type="date"
              name="shipDate"
              value={formData.shipDate}
              onChange={handleChange}
              readOnly={isViewMode}
              plaintext={isViewMode}
            />
          </Form.Group>

          <Form.Group controlId="formArrivalDate" className="mb-3">
            <Form.Label>{t('shipInfo.fields.arrivalDate')}</Form.Label>
            <Form.Control
              type="date"
              name="arrivalDate"
              value={formData.arrivalDate}
              onChange={handleChange}
              readOnly={isViewMode}
              plaintext={isViewMode}
            />
          </Form.Group>

          <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              {t('uiInterface.cancel')}
            </Button>
            {!isViewMode && (
              <Button type="submit" variant="primary">
                {t('uiInterface.save')}
              </Button>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ShippingInfoModal;